
import {Options, Vue} from "vue-class-component";
import {Speaker} from "@/entities/Speaker";
import {Speech} from "@/entities/Speech";
import {isDefined} from "@/utils";


@Options({
  props:{
    getLangForSpeech: {
      required: true,
      type: Function
    },
  }
})
export default class SpeakerDetailDialog extends Vue {


  private speeches: Speech[];
  private speaker: Speaker;
  private isOpen: boolean = false;
  private getLangForSpeech: (id) => string;

  constructor(props) {
    super(props);
  }

  public openDialog(speaker: Speaker, speeches: Speech[]): void {
    this.addClickListener();
    this.speeches = speeches;
    this.speaker = speaker;
    this.isOpen = true;
  }

  private addClickListener() {
    window.addEventListener('click', this.onClick);
  }

  private onClick(event) {
    if (isDefined(this.$refs.container) && this.isOpen) {
      const container = this.$refs.container as any;
      if (isDefined(container)) {
        if (!container.contains(event.target)) {
          this.closeDialog();
        }
      }
    }
  }

  private removeClickListener() {
    window.removeEventListener('click', this.onClick);
  }

  public closeDialog(): void {
    this.removeClickListener();
    this.isOpen = false;
  }

  public getLangForSpeechById(id) {
    if (isDefined(this.getLangForSpeech)) {
      return this.getLangForSpeech(id);
    }
  }


}
